import { render, staticRenderFns } from "./PriceEditPage.vue?vue&type=template&id=c613a506&scoped=true"
import script from "./PriceEditPage.vue?vue&type=script&lang=js"
export * from "./PriceEditPage.vue?vue&type=script&lang=js"
import style0 from "./PriceEditPage.vue?vue&type=style&index=0&id=c613a506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c613a506",
  null
  
)

export default component.exports